var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.816 18.9999C12.8595 18.9999 11.2023 18.321 9.8445 16.9631C8.48667 15.6053 7.80775 13.9481 7.80775 11.9916C7.80775 10.0496 8.48667 8.3989 9.8445 7.0394C11.2023 5.67973 12.8595 4.9999 14.816 4.9999C16.7578 4.9999 18.4086 5.67973 19.7683 7.0394C21.1279 8.3989 21.8078 10.0496 21.8078 11.9916C21.8078 13.9481 21.1279 15.6053 19.7683 16.9631C18.4086 18.321 16.7578 18.9999 14.816 18.9999ZM14.8078 17.9999C16.4744 17.9999 17.8911 17.4166 19.0578 16.2499C20.2244 15.0832 20.8078 13.6666 20.8078 11.9999C20.8078 10.3332 20.2244 8.91656 19.0578 7.7499C17.8911 6.58323 16.4744 5.9999 14.8078 5.9999C13.1411 5.9999 11.7244 6.58323 10.5578 7.7499C9.39108 8.91656 8.80775 10.3332 8.80775 11.9999C8.80775 13.6666 9.39108 15.0832 10.5578 16.2499C11.7244 17.4166 13.1411 17.9999 14.8078 17.9999ZM17.275 15.2056L17.9885 14.4921L15.3078 11.8114V8.30765H14.3078V12.2134L17.275 15.2056ZM3.19225 8.4999V7.4999H6.80775V8.4999H3.19225ZM2.19225 12.4999V11.4999H6.80775V12.4999H2.19225ZM3.19225 16.4999V15.4999H6.80775V16.4999H3.19225Z",
    fill: "#FF9816"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockImg);
export default __webpack_public_path__ + "static/media/clock_img.49e14b15fd0b68af80f5d2d6c0b60931.svg";
export { ForwardRef as ReactComponent };